import { Timestamp, TranslateFunction, WeekDays } from '@griply/types';

import { getCalendarEventRepeatLabel } from './get-calendar-event-repeat-label';

export type GetCalendarEventRepeatDisplayOptions = {
  rrule: string | null;
  seriesRrule?: string | null;
  isRecurring?: boolean;
  // the event's own start: a rule that omits its BY* parts implies them from this day
  startDate: Timestamp;
  t: TranslateFunction;
  weekStartsOn?: WeekDays;
};

export type CalendarEventRepeatDisplay = {
  repeats: boolean;
  isSeriesPatternUnknown: boolean;
  label: string | null;
};

export const getCalendarEventRepeatDisplay = ({
  rrule,
  seriesRrule,
  isRecurring,
  startDate,
  t,
  weekStartsOn,
}: GetCalendarEventRepeatDisplayOptions): CalendarEventRepeatDisplay => {
  // the master's rule only speaks for an event the series already claims
  const effectiveRrule = rrule ?? (isRecurring ? seriesRrule ?? null : null);

  return {
    repeats: !!rrule || !!isRecurring,
    isSeriesPatternUnknown: !rrule && !!isRecurring,
    label: getCalendarEventRepeatLabel(
      effectiveRrule,
      startDate,
      t,
      weekStartsOn,
    ),
  };
};
